<template>
    <div class="modal fade" id="applyImplantConfirmModalTmp" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εφαρμογής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Εφαρμογή του μοσχεύματος;</p>
                </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal" @click="cancelModalTmp"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="tempSave"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="applyImplantConfirmModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εφαρμογής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Εφαρμογή του μοσχεύματος;</p>
                </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal" @click="cancelModal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="save"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="applyModalLabel">Δήλωση Eφαρμογής Mοσχεύματος</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex mt-3 mb-2">
                        <label class="col-md-4 mt-1">Κωδικός SEC:</label>
                        <input type="text" maxlength="40" class="form-control" id="sec" name="sec" v-model="sec" placeholder="Εισάγετε κωδικό SEC" required/>
                    </div>
                    <div class="d-flex mt-3 mb-2">
                        <label class="col-md-4 mt-1">Κατηγορία:</label>
                        <select id="categoryId" name="categoryId" class="form-control" v-model="selectedCategoryId"
                            placeholder="Επιλέξτε κατηγορία" required>
                            <option value="" selected>Επιλέξτε κατηγορία</option>
                            <option v-for="category in categories" :key="category.id" :value="category.id">{{
                                category.category }}</option>
                        </select>
                    </div>
                    <div class="d-flex mt-3 mb-2">
                        <label class="col-md-4 mt-1">Επιλέξτε μόσχευμα:</label>
                        <select id="implant" name="implant" class="form-control" v-model="implantId"
                            placeholder="Επιλέξτε μόσχευμα" required>
                            <option value="" selected>Επιλέξτε μόσχευμα</option>
                            <option v-for="implant in implants" :key="implant.id" :value="implant.id">{{
                                implant.implant }}</option>
                        </select>
                    </div>
                    <div class="d-flex mt-3 mb-2">
                        <label class="col-md-4 mt-1">Επιλέξτε Ίδρυμα ιστών:</label>
                        <select id="implant" name="implant" class="form-control" v-model="instId"
                            placeholder="Επιλέξτε Ίδρυμα ιστών" required>
                            <option value="" selected>Επιλέξτε Ίδρυμα ιστών</option>
                            <option v-for="institute in institutes" :key="institute.id" :value="institute.id">{{
                                institute.title }}</option>
                        </select>
                    </div>
                    <!-- <div class="d-flex mt-3 mb-2">
                        <label class="col-md-4 mt-1">Επιλέξτε Προμηθευτή:</label>
                        <select id="implant" name="implant" class="form-control" v-model="provId"
                            placeholder="Επιλέξτε Προμηθευτή">
                            <option value="" selected>Επιλέξτε Προμηθευτή</option>
                            <option v-for="provider in providers" :key="provider.id" :value="provider.id">{{
                                provider.title }}</option>
                        </select>
                    </div> -->
                    <div class="d-flex mt-3 mb-2">
    <div class="d-flex flex-grow-1 me-3 col-md-6">
        <label class="mt-1">Ημ/νία εφαρμογής μοσχεύματος:</label>
        <input type="date" class="form-control" id="applyDate" name="applyDate" v-model="applyDate" placeholder="Επιλέξτε ημ/νία εφαρμογής" required/>
    </div>
    <div class="d-flex flex-grow-1">
        <label class="col-md-4 mt-2">ΑΜΚΑ:</label>
        <input type="text" maxlength="11" class="form-control" id="amka" name="amka" v-model="amka" placeholder="Εισάγετε ΑΜΚΑ" required/>
    </div>
</div>

                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn" @click="tmpSaveModal"><img src="../assets/images/temp16.png"
                            alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Προσωρινή
                        αποθήκευση</button>
                    <div class="d-flex">
                        <button type="button" class="btn" data-bs-dismiss="modal"><img
                                src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Άκυρο</button>
                        <button type="button" class="btn ms-2" @click="saveModal"><img src="../assets/images/save16.png"
                                alt="Citrine Logo" class="menu-img"
                                style="width:1.1em; margin-right:10px">Υποβολή</button>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { getNotUsed, downloadExportInstall, downloadFile, downloadExportNotUsed, fetchUserInfo, getInstitutions } from "../services/institutions";
import { deleteHospitalById, downloadExportHospitals, getHospitals, getHospitalsAll, getHospitalsForInstitute, postHospital } from "@/services/hospitals";
import { getGrafts, getGraftCategories, postCategory, postImplant, actImplant, deleteRelationsForImplant, instToHosp, useImplant, getImplantBySec, importImplantStatement } from "@/services/grafts";
import { useToast } from "vue-toastification";
import apiClient from "@/services/api";
import * as XLSX from 'xlsx';
import { actProvider, deleteRelationsForProvider, getCountries, getSuppliers, postProvider } from "@/services/suppliers";
import { getProvidersForInstitute } from "@/services/provider";

export default {
    data() {
        return {
            provId: "",
            instId: "",
            providers: [],
            institutes: [],
            implants: [],
            categories: [],
            implantId: "",
            selectedCategoryId: "",
            sec: "",
            amka: "",
            applyDate: "",
            selectedHospitalId: "",
            selectedHospitalAfm: null,
            searchField: "",
            searchValue: "",
            implants: [],
            hospitals: [],
            installedImplants: [],
            notUsedImplants: [],
            usedImplants: [],
            expiredImplants: [],
            paginationLinks: [],
            page: 1,
            selectedInsituteId: "0",
            selectedImplant: null,
            sortKey: "id",
            sortOrder: "desc",
            selectedField: "",
            implantShown: false,
            selectedRow: null,

        };
    },
    computed: {
        isFormValid() {
            return (
                this.amka.length === 11 &&
                this.sec.length === 40 &&
                this.selectedCategoryId !== "" &&
                this.implantId !== "" &&
                this.instId !== "" &&
                this.applyDate !== ""
            );
        },
    },
    methods: {
        saveModal() {
            if (this.sec.length != 40) {
                useToast().error('Το πεδίο sec πρέπει να είναι ακριβώς 40 ψηφία');
                return;
            }
            if (this.selectedCategoryId == '') {
                useToast().error('Το πεδίο κατηγορία είναι απαραίτητο');
                return;
            }
            if (this.implantId == '') {
                useToast().error('Το πεδίο μόσχευμα είναι απαραίτητο');
                return;
            }
            if (this.instId == '') {
                useToast().error('Το πεδίο ίδρυμα ιστών είναι απαραίτητο');
                return;
            }
            if (this.applyDate == '') {
                useToast().error('Το πεδίο ημ/νία εφαρμογής είναι απαραίτητο');
                return;
            }
            const date = new Date();
            const applyInDate = new Date(this.applyDate);
            if (applyInDate > date) {
                useToast().error('Η ημερομηνία εφαρμογής δεν μπορεί να είναι μεταγενέστερη της σημερινής.');
                return;
            }
            if (!this.implantId) {
                useToast().error('Πρέπει να επιλέξετε μόσχευμα');
                return;
            }
            if (this.amka.length != 11) {
                useToast().error('Το πεδίο ΑΜΚΑ πρέπει να είναι ακριβώς 11 ψηφία');
                return;
            }
            $("#applyImplantConfirmModal").modal('show');
            $("#applyModal").modal('hide');
        },
        cancelModal() {
            $("#applyImplantConfirmModal").modal('hide');
            $("#applyModal").modal('show');
        },
        tmpSaveModal() {
            if (this.sec.length != 40) {
                useToast().error('Το πεδίο sec πρέπει να είναι ακριβώς 40 ψηφία');
                return;
            }
            if (this.selectedCategoryId == '') {
                useToast().error('Το πεδίο κατηγορία είναι απαραίτητο');
                return;
            }
            if (this.implantId == '') {
                useToast().error('Το πεδίο μόσχευμα είναι απαραίτητο');
                return;
            }
            if (this.instId == '') {
                useToast().error('Το πεδίο ίδρυμα ιστών είναι απαραίτητο');
                return;
            }
            if (this.applyDate == '') {
                useToast().error('Το πεδίο ημ/νία εφαρμογής είναι απαραίτητο');
                return;
            }
            const date = new Date();
            const applyInDate = new Date(this.applyDate);
            if (applyInDate > date) {
                useToast().error('Η ημερομηνία εφαρμογής δεν μπορεί να είναι μεταγενέστερη της σημερινής.');
                return;
            }
            if (!this.implantId) {
                useToast().error('Πρέπει να επιλέξετε μόσχευμα');
                return;
            }
            if (this.amka.length != 11) {
                useToast().error('Το πεδίο ΑΜΚΑ πρέπει να είναι ακριβώς 11 ψηφία');
                return;
            }
            $("#applyImplantConfirmModalTmp").modal('show');
            $("#applyModal").modal('hide');
        },
        cancelModalTmp() {
            $("#applyImplantConfirmModalTmp").modal('hide');
            $("#applyModal").modal('show');
        },
        async tempSave() {
            const userInfo = await fetchUserInfo();
            const secResponse = await getImplantBySec({seccode: this.sec});
            if (secResponse.data.success && secResponse.data.data) {
                const response = await useImplant({ id: secResponse.data.data, hospid: userInfo.data.hospital.id, amka: this.amka, apply_date: this.applyDate, istemp: 1, apply_status: 0 });
                if (response.data.success) {
                    $("#applyImplantConfirmModalTmp").modal('hide');
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                } else {
                    useToast().error(response.data.message);
                }
            } else {
                const response = await importImplantStatement({
                    id: 0,
                    implant_id: this.implantId,
                    institude_id: this.instId,
                    provider_id: this.provId,
                    hosp_id: userInfo.data.hospital.id,
                    sec: this.sec,
                    origin: 0,
                    transtype: 0,
                    inst_recvdate: this.applyDate,
                    custom: 0,
                    proto_num: 0,
                    proto_date:null,
                    status: 1,
                    apply_date: this.applyDate,
                    amka: this.amka,
                    apply_hospital_id: userInfo.data.hospital.id,
                    prov_hospital_id: userInfo.data.hospital.id,
                    apply_status: 1,
                    exp_date: null,
                    istemp_inst: 0,
                    istemp_hosp: 1
                });
                if (response.data.success) {
                    $("#applyImplantConfirmModalTmp").modal('hide');
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                } else {
                    useToast().error(response.data.message);
                }
            }

        },
        async save() {
            const userInfo = await fetchUserInfo();
            const secResponse = await getImplantBySec({seccode: this.sec});
            if (secResponse.data.success && secResponse.data.data) {
                const response = await useImplant({ id: secResponse.data.data, hospid: userInfo.data.hospital.id, amka: this.amka, apply_date: this.applyDate, istemp: 0, apply_status: 0 });
                if (response.data.success) {
                    $("#applyImplantConfirmModal").modal('hide');
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                } else {
                    useToast().error(response.data.message);
                }
            } else {
                const response = await importImplantStatement({
                    id: 0,
                    implant_id: this.implantId,
                    institude_id: this.instId,
                    provider_id: this.provId,
                    hosp_id: userInfo.data.hospital.id,
                    sec: this.sec,
                    origin: 0,
                    transtype: 0,
                    inst_recvdate: this.applyDate,
                    custom: 0,
                    proto_num: 0,
                    proto_date: null,
                    status: 1,
                    apply_date: this.applyDate,
                    amka: this.amka,
                    apply_hospital_id: userInfo.data.hospital.id,
                    prov_hospital_id: userInfo.data.hospital.id,
                    apply_status: 1,
                    exp_date: null,
                    istemp_inst: 0,
                    istemp_hosp: 0
                });
                if (response.data.success) {
                    $("#applyImplantConfirmModal").modal('hide');
                    useToast().success('Επιτυχής δήλωση εφαρμογής μοσχεύματος');
                } else {
                    useToast().error(response.data.message);
                }
            }
        },
        limitSec(sec) {
            if (sec && sec.length > 10) {
                return sec.substring(0, 10) + '...';
            }
            return sec;
        },
        async openApplyModal() {
            $("#applyModal").modal('toggle');
            const userInfo = await fetchUserInfo();
            const hospitalsResponse = await getHospitalsForInstitute({ instid: userInfo.data.institution.id });
            if (hospitalsResponse.data.success) {
                this.hospitals = hospitalsResponse.data.data;
            }
        },
        printPreview() {
            $("#printModal").modal('toggle');

            apiClient.get('/eomws/print-implant/' + this.selectedImplant.id, {
                responseType: 'text', // Expect text to handle HTML responses
                headers: {
                    "Accept": "text/html", // Expect an HTML response
                },
            })
                .then((response) => {
                    // Close the modal
                    setTimeout(() => {
                        $("#printModal").modal('hide');
                    }, 1000);

                    // Check the content type of the response
                    const contentType = response.headers['content-type'];
                    if (contentType.includes('text/html')) {
                        // Create an iframe element
                        const iframe = document.createElement('iframe');
                        iframe.style.position = 'absolute';
                        iframe.style.top = '0';
                        iframe.style.left = '0';
                        iframe.style.width = '0';
                        iframe.style.height = '0';
                        iframe.style.border = 'none';
                        document.body.appendChild(iframe);

                        // Write the printable content into the iframe
                        const iframeDoc = iframe.contentWindow.document;
                        iframeDoc.open();
                        iframeDoc.write(response.data); // Write the HTML content to the iframe
                        iframeDoc.close();

                        // Wait for the content to load, then print
                        iframe.onload = () => {
                            iframe.contentWindow.focus();
                            iframe.contentWindow.print();

                            // Clean up after printing
                            setTimeout(() => {
                                document.body.removeChild(iframe); // Remove the iframe after printing
                            }, 1000); // Delay to ensure the print dialog is completed
                        };
                    } else {
                        console.error('Unexpected content type:', contentType);
                    }
                })
                .catch((error) => {
                    // Close the modal and log the error
                    $("#printModal").modal('toggle');
                    console.error('Error in print preview:', error);
                });
        },
        download() {
            if (!this.selectedImplant.file_name) {
                useToast().error('Δεν υπάρχει αρχείο!');
            } else {
                downloadFile(this.selectedImplant.id, this.selectedImplant.file_name, this.selectedImplant.mime_type);
            }
        },
        closeDetails() {
            this.implantShown = false;
        },
        onChangeHospital() {
            let hospital = null;
            for (let i = 0; i < this.institutions.length; i++) {
                if (this.institutions[i].id == $("#hospital").val()) {
                    hospital = this.institutions[i];
                }
            }
            if (hospital) {
                this.selectedHospitalAfm = hospital.afm;
            } else {
                this.selectedHospitalAfm = null;
            }
        },
        showImplant(implant) {
            this.selectedImplant = implant;
            this.implantShown = true;
            this.selectedRow = implant;
        },
        sortTable(column) {
            if (this.sortKey === column) {
                // Reverse order if the column is already sorted
                this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
            } else {
                this.sortKey = column;
                this.sortOrder = "asc";
            }
            this.handleRefresh();
        },
        getPageFromUrl(url) {
            if (!url) return null;
            const urlObj = new URL(url, window.location.origin);
            return urlObj.searchParams.get('page');
        },
        resetInstitute() {
            this.selectedInsituteId = "0";
            this.handleRefresh();
        },
        async handleRefresh() {
            const userInfo = await fetchUserInfo();
            const implantsResponse = await getGrafts({catid: this.selectedCategoryId});
            const providersResponse = await getProvidersForInstitute({instid: this.instId});
            if (providersResponse.data.success) {
                this.providers = providersResponse.data.data;
            }
            if (implantsResponse.data.success) {
                this.implants = implantsResponse.data.data;
            }
        },
        async handleExport() {
            let params = {
                sortBy: this.sortKey,
                sortOrder: this.sortOrder,
                page: this.page
            };
            if (this.searchField != "" && this.searchValue != "") {
                params[this.searchField] = this.searchValue;
            }
            const userInfo = await fetchUserInfo();
            params.hospid = userInfo.data.hospital.id;
            downloadExportNotUsed(params);
        },
        formatLicenseExp(date) {
            if (date == null) { return ''}
            return new Date(date).toLocaleDateString("el-GR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        openApplyModal() {
            $("#applyModal").modal('show');
        }
    },
    async mounted() {
        const userInfo = await fetchUserInfo();
        const categoriesResponse = await getGraftCategories();
        if (categoriesResponse.data.success) {
            this.categories = categoriesResponse.data.data;
        }
        const institutionsResponse = await getInstitutions();
        if (institutionsResponse.data.success) {
            this.institutes = institutionsResponse.data.data;
        }
        this.openApplyModal();
        $('a[href="/apply-implant-hospital"]').on('click', this.openApplyModal);
    },
    unmounted() {
        $('a[href="/apply-implant-hospital"]').off('click', this.openApplyModal);
    },
    watch: {
        selectedCategoryId: {
            immediate: true,
            handler() {
                this.handleRefresh();
            }
        },
        instId: {
            immediate: true,
            handler() {
                this.handleRefresh();
            }
        },
    }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
    width: 100%;
}

.btn {
    background-color: #f6f6f6;
}

.btn:hover,
.btn-md:hover {
    background-color: #ececec;
}

.btn-md {
    background-color: white;
    border: none;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%;
    /* Ensures the layout fits the screen height */
    overflow: hidden;
    /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1;
    /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0;
    /* Prevent the content from overflowing */
    padding-right: 10px;
    /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68;
    /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32;
    /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px;
    /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px);
    /* Default to full width */
    padding-left: 10px;
    font-size: medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d;
    /* Muted text for the label */
    margin-bottom: 5px;
    display: block;
    /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%;
    /* Ensure table stays within bounds */
    table-layout: fixed;
    /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word;
    /* Handle long text gracefully */
}

th,
td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}


.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text,
.value-text {
    font-size: small;
}

.active2 {
    background-color: #ffefbb;
    /* Light blue background */
    font-weight: bold;
    /* Make the text bold */
}

.modal-header {
    background-color: #6DB4E3;
}

.modal-title {
    color: white;
}

.modal-content {
    border: none;
    margin-top: 5vw;
}
</style>